import { api } from './apiSlice';
import { AbsenceBalanceHistoryDto, BalanceHistoryFilters } from '../types/balanceHistory';
import { PaginatedList, PaginationParams } from '../types/pagination';
import { unwrapApiResponse } from '../utils/apiUtils';

export const balanceHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get current user's balance history
    getMyBalanceHistory: builder.query<
      PaginatedList<AbsenceBalanceHistoryDto>,
      { paginationParams?: PaginationParams } & Partial<BalanceHistoryFilters>
    >({
      query: ({ paginationParams, ...filters }) => ({
        url: 'absence-balance-history/me',
        params: {
          ...paginationParams,
          ...filters,
        },
      }),
      transformResponse: unwrapApiResponse,
      providesTags: ['AbsenceBalances'],
    }),

    // Get all balance history (admin only)
    getAllBalanceHistory: builder.query<
      PaginatedList<AbsenceBalanceHistoryDto>,
      { paginationParams?: PaginationParams } & Partial<BalanceHistoryFilters>
    >({
      query: ({ paginationParams, ...filters }) => ({
        url: 'absence-balance-history/all',
        params: {
          ...paginationParams,
          ...filters,
        },
      }),
      transformResponse: unwrapApiResponse,
      providesTags: ['AbsenceBalances'],
    }),
  }),
});

export const {
  useGetMyBalanceHistoryQuery,
  useGetAllBalanceHistoryQuery,
} = balanceHistoryApi;


